/* eslint-disable react/destructuring-assignment */
import * as React from 'react';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import Close from '@icon/Close';
import Image from '@base/Image';
import { Dialog } from '@material-ui/core';
import { segment } from '@actions/analytics';
import { evtNameCategoryMap } from '@constants/index';
import { SYLLABUS_CLICKED_KEYS } from '@constants/segment';
import useGoalEventProps from '@hooks/useGoalEventProps';
import { useRouter } from 'next/router';
import { EPUB_NOTES, NOTES_IMAGE_VIEWED } from './utils';
import { EpubContext } from './Context/EpubContext';

interface ImageViewerProps {
  imageSrc?: string;
  imageHeight?: number;
  imageWidth?: number;
  open: boolean;
  onClose: () => void;
}

const Wrapper = styled.div`
  background: var(--color-base-0);
  padding-bottom: ${Spacings.SPACING_18B};
`;

const Header = styled.div`
  height: ${Spacings.SPACING_18B};
  padding-right: ${Spacings.SPACING_6B};
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
`;

const StyIcon = styled(Close)`
  cursor: pointer;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-right: 168px;
  padding-left: 168px;
`;

const StyDialog = styled(Dialog)`
  .MuiDialog-paperWidthSm {
    max-width: max-content;
  }
  .MuiPaper-rounded {
    border-radius: ${Spacings.SPACING_2B};
  }
`;

const ImageViewer: React.FC<ImageViewerProps> = ({
  imageSrc,
  imageHeight,
  imageWidth,
  open,
  onClose
}) => {
  const {
    query: { goalUID, topicUID }
  } = useRouter();
  const goalSegmentData = useGoalEventProps({ goalUID: goalUID as string });
  const { currentNotesUID } = React.useContext(EpubContext);
  React.useEffect(() => {
    if (open)
      segment.track(
        NOTES_IMAGE_VIEWED,
        {
          ...goalSegmentData,
          last_primary_source: EPUB_NOTES,
          last_primary_source_section: EPUB_NOTES,
          notes_uid: currentNotesUID,
          notes_topic: topicUID
        },
        evtNameCategoryMap.WITHOUT_CATEGORY,
        true,
        SYLLABUS_CLICKED_KEYS
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  return (
    <StyDialog open={open} onClose={onClose}>
      <Wrapper>
        <Header>
          <StyIcon
            color="var(--color-text-primary)"
            height={Spacings.SPACING_6B}
            width={Spacings.SPACING_6B}
            onClick={onClose}
          />
        </Header>
        <ImageWrapper>
          {imageSrc ? (
            <Image
              src={imageSrc}
              height={imageHeight * 1.42}
              width={imageWidth * 1.42}
              alt="Notes"
            />
          ) : null}
        </ImageWrapper>
      </Wrapper>
    </StyDialog>
  );
};

export default ImageViewer;
